import { GROWTH_WHATSAPP_GROUPS_SEARCH, GROWTH_WHATSAPP_GROUPS_EDIT_GROUP, GROWTH_WHATSAPP_GROUPS_GROUP_CREATION_REQUEST, GROWTH_WHATSAPP_GROUPS_GROUP_DELETION_REQUEST, GROWTH_WHATSAPP_GROUPS_MEMBER_REMOVAL_REQUEST, GROWTH_WHATSAPP_GROUPS_REQUEST_ADD_MEMBERS, GROWTH_WHATSAPP_GROUPS_REQUEST_CHANGE_IMAGE, GROWTH_WHATSAPP_GROUPS_GROUP_DELETION_GIVEUP, GROWTH_WHATSAPP_GROUPS_MEMBERS_REMOVAL_GIVEUP, } from './GroupsSegmentEvents';
export class GroupsSegmentService {
    static $inject = ['SegmentService'];
    constructor(SegmentService) {
        'ngInject';
        this.SegmentService = SegmentService;
    }
    async trackGroupsEditGroup(application, group) {
        await this.trackApplicationEvent(application, GROWTH_WHATSAPP_GROUPS_EDIT_GROUP, { group });
    }
    async trackGroupsSearchGroup(application, searchTerm) {
        await this.trackApplicationEvent(application, GROWTH_WHATSAPP_GROUPS_SEARCH, { searchTerm });
    }
    async trackGroupsCreateGroupRequest(application, request) {
        await this.trackApplicationEvent(application, GROWTH_WHATSAPP_GROUPS_GROUP_CREATION_REQUEST, { request });
    }
    async trackGroupsDeleteGroupRequest(application, groupId) {
        await this.trackApplicationEvent(application, GROWTH_WHATSAPP_GROUPS_GROUP_DELETION_REQUEST, { groupId });
    }
    async trackGroupDeletionGiveUp(application, groupId) {
        await this.trackApplicationEvent(application, GROWTH_WHATSAPP_GROUPS_GROUP_DELETION_GIVEUP, { groupId });
    }
    async trackGroupUpdateImageRequest(application, request, groupId) {
        await this.trackApplicationEvent(application, GROWTH_WHATSAPP_GROUPS_REQUEST_CHANGE_IMAGE, { request, groupId });
    }
    async trackGroupAddMembersRequest(application, members, groupId) {
        await this.trackApplicationEvent(application, GROWTH_WHATSAPP_GROUPS_REQUEST_ADD_MEMBERS, { members, groupId });
    }
    async trackGroupRemoveMembersRequest(application, members, groupId) {
        await this.trackApplicationEvent(application, GROWTH_WHATSAPP_GROUPS_MEMBER_REMOVAL_REQUEST, { members, groupId });
    }
    async trackGroupMembersRemovalGiveUp(application, members, groupId) {
        await this.trackApplicationEvent(application, GROWTH_WHATSAPP_GROUPS_MEMBERS_REMOVAL_GIVEUP, { members, groupId });
    }
    async trackApplicationEvent(application, event, payload) {
        await this.SegmentService.createApplicationTrack({
            trackEvent: event,
            application,
            payload: { ...payload },
        });
    }
}
GroupsSegmentService.$inject = ['SegmentService'];
